import React from "react";
import PropTypes from "prop-types";
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'


const Error = ({message, hasError}) => {
  const replacedMessage = message.replace('\\n', '\n');
  if (hasError) {
    return (
      // 改行表示を行うために 'pre-line' を埋め込んでいます。
      <div className="error_massage" style={{whiteSpace: 'pre-line'}}>{replacedMessage}</div>
    )
  } else {
    return null
  }
};

Error.propTypes = {
  message: PropTypes.string,
  hasError: PropTypes.bool,
};

export default Error;